import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import {useParams} from 'react-router'
import clubStore from '../../storage/ClubStore'
import ClubMenu from './Menu/ClubMenu'

const Club = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.getClub(args.id)
  }, [args])
  return (
    <div>
      <ClubMenu/>
      <h3>{clubStore.club.name}</h3>
    </div>
  );
};

export default observer(Club);